export const INITIAL_STATE = {
    isAuth: null,
    sessionApiStatus: null,
    loginId: "",
    profile: {
        state: null,
        contents: null,
    },
    profilePictureUrl: "",
    clientLogoUrl: "",
};

export const PICTURE_TYPE = {
    PROFILE_PIC: "PROFILE_PIC",
    COMPANY_PIC: "LOGO"
};

